<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>健康在线</el-breadcrumb-item>
        <el-breadcrumb-item>反馈列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="hx-form-container box-shadow">
      <el-form ref="listForm" :model="listParams" label-width="120px" inline>
        <el-form-item label="回复状态：" prop="replyStatus">
          <el-select clearable size="small" v-model="listParams.replyStatus" style="width: 100%" placeholder="请选择回复状态">
            <el-option v-for="item in statusList" :label="item.title" :value="item.replyStatus" :key="item.title"> </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button size="small" type="primary" @click="loadTableData"> 查询 </el-button>
          <el-button size="small" @click="resetForm('listForm')"> 重置 </el-button>
        </el-form-item>
      </el-form>
    </div>
    <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display" style="height: 32px">
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" max-height="600" border>
        <el-table-column prop="id" align="center" label="id" />

        <el-table-column prop="title" align="center" label="反馈标题" />

        <el-table-column prop="category" align="center" label="反馈模块" />

        <el-table-column prop="receiver" align="center" label="反馈接收单位" />

        <el-table-column prop="creator" align="center" label="反馈用户" />

        <el-table-column prop="replyStatusTxt" align="center" label="回复状态" />

        <el-table-column prop="contact" align="center" label="联系方式" />

        <el-table-column prop="logisticsSites" align="center" label="供应点" />

        <el-table-column prop="userMsgCount" align="center" label="反馈次数" />

        <el-table-column prop="publishTime" align="center" label="反馈时间">
          <template slot-scope="scope">
            <span v-if="scope.row.publishTime">{{ scope.row.publishTime | formatDate }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="lastReplyBy" align="center" label="操作人"> </el-table-column>

        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="linkToDetailPage(scope.row.id)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>
  </div>
</template>

<script>
import _ from "lodash";
export default {
  data() {
    return {
      listParams: {
        replyStatus: "0",
        categoryId: "2",
        receiverId: "",
      },
      statusList: [
        { replyStatus: "", title: "全部" },
        { replyStatus: "1", title: "已回复" },
        { replyStatus: "0", title: "等待回复" },
      ],
      moduleTotalList: [],
      moduleList: [{ categoryId: "", title: "全部" }],
      receiveUnitList: [{ receiverId: "", title: "全部" }],
      tableLoading: false,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
    };
  },
  mounted() {
    this.loadModules();
    this.loadTableData();
  },
  methods: {
    /**
     * 初始化反馈模块及接收单位数据列表
     */
    loadModules() {
      this.$http({
        url: global.apiUrl + "/feedback/category",
        method: "GET",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.moduleTotalList = res.body.data;
            if (this.moduleTotalList) {
              this.moduleTotalList.map(item => {
                this.moduleList.push({
                  categoryId: item.categoryId,
                  title: item.title,
                });
              });
            }
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 监听模块数据变化
     * @param val
     */
    watchModule(val) {
      if (val) {
        this.moduleTotalList.map(item => {
          if (val === item.categoryId) {
            this.receiveUnitList = item.receiver;
          }
        });
        this.receiveUnitList.unshift({ receiverId: "", title: "全部" });
      }
    },
    /**
     * 加载列表数据
     */
    loadTableData() {
      const bodyParams = Object.assign(this.listParams, {
        pageIndex: this.pager.pageIndex,
        pageSize: this.pager.pageSize,
      });
      // for (let key in bodyParams) {
      // 	if (bodyParams[key]) {
      // 		bodyParams[key] = parseInt(bodyParams[key]);
      // 	}
      // }
      this.tableLoading = true;
      this.$http({
        url: global.apiUrl + "/feedback/topic",
        method: "GET",
        params: bodyParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            if (res.body.data) {
              this.tableData = res.body.data.dataList;
              this.pager.total = res.body.data.total;
            } else {
              this.tableData = [];
            }
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    /**
     * 重置请求表单
     * @param name
     */
    resetForm(name) {
      this.$refs[name].resetFields();
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
    /**
     * 跳转至详情页面
     * @param id
     */
    linkToDetailPage(id) {
      this.$router.push({
        name: "healthFeedbackDetail",
        query: {
          topicId: id,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
}
</style>
